import { render, staticRenderFns } from "./FlatGuestBox.vue?vue&type=template&id=0f367a7d&scoped=true&"
import script from "./FlatGuestBox.vue?vue&type=script&lang=js&"
export * from "./FlatGuestBox.vue?vue&type=script&lang=js&"
import style0 from "./FlatGuestBox.vue?vue&type=style&index=0&id=0f367a7d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f367a7d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f367a7d')) {
      api.createRecord('0f367a7d', component.options)
    } else {
      api.reload('0f367a7d', component.options)
    }
    module.hot.accept("./FlatGuestBox.vue?vue&type=template&id=0f367a7d&scoped=true&", function () {
      api.rerender('0f367a7d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Gc08WG0ACP1A/JS/comp/FlatGuestBox.vue"
export default component.exports